module.exports = "data:image/gif;base64,R0lGODlhCgAKAPAAAAAAAPgLHiH5BAkoAAAAIf8LTkVUU0NBUEUyLjADAQAAACwAAAAACgAKAAACEoSPF7vIb54EElZGb8g3VgcBBQAh+QQJKAAAACwAAAAACgAKAIAAAAD+UF4CEoSPF7vIb54EElZGb8g3VgcBBQAh+QQJKAAAACwAAAAACgAKAIAAAAAAAAACCISPqcvtD2MrADs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ponto.gif
// module id = Jc22
// module chunks = 2